/*
 * @Author: xujinjin7
 * @Date: 2025-03-19 11:15:00
 * @LastEditTime: 2025-10-17 16:33:41
 * @LastEditors: xujinjin7
 * @Description:
 */
import enObj from "@/locale/lang/en.json";
import zhObj from "@/locale//lang/zh.json";
const mixin = {
  data() {
    return {
      zhObj,
    };
  },
  computed: {
    isIntl: function () {
      if (process.env.NODE_ENV === "production") {
        return process.env.VUE_APP_BASE_API === "intl";
      } else {
        // 本地联调环境判断 国内 还是国际 true 是国际  false 是国内
        return false;
      }
    },
  },
  methods: {
    getErrorCodeMsg(res = {}) {
      const { code, message = "Failed" } = res || {};
      if (["UI008", "UI009", "IG004"].includes(code)) return;
      let msgCode = `code_${code}`;
      let obj = this.$i18n && this.$i18n.locale === "zh" ? zhObj : enObj;
      return this.$message.warning(obj[msgCode] || message);
    },
    getErrorCodeMsgText(res = {}) {
      const { code, message = "Failed" } = res || {};
      let msgCode = `code_${code}`;
      let obj = this.$i18n && this.$i18n.locale === "zh" ? zhObj : enObj;
      return obj[msgCode] || message;
    },
    isHasPermission(str) {
      const permissionList =
        JSON.parse(localStorage.getItem("permissionList")) || [];
      if (!permissionList.includes(str)) {
        this.$message.warning(this.$t("no_permission_text"));
      }
      return permissionList.includes(str);
    },
    handleBrowser() {
      const ua = navigator.userAgent;
      if (ua.includes("Edg") || ua.includes("Edge")) {
        return "Edge";
      } else if (ua.includes("Firefox")) {
        return "Firefox";
      } else if (ua.includes("QQBrowser")) {
        return "QQ";
      } else if (ua.includes("Quark") || ua.includes("QHBrowser")) {
        return "Quark";
      } else if (ua.includes("360SE") || ua.includes("360EE")) {
        return "360";
      } else if (ua.includes("Chrome")) {
        return "Chrome";
      } else {
        return "Unknown";
      }
    },
  },
};
export default mixin;
